import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import mq from '@/utils/media-queries';

import { clearfix, toVw, col, toVwMobile } from '../../../utils/styles';
import { LARGE_COL_WIDTH } from '../../../constants';
import ContactsRotator from './ContactsRotator';

const Styled = styled.div`
  ${clearfix};
`;

const Col = styled.div`
  ${col};
  color: #fff;

  &:first-child {
    width: ${toVw(LARGE_COL_WIDTH)};
  }

  ${mq.tablet(css`
    && {
      width: 50%;
    }
  `)};

  ${mq.mobile(css`
    && {
      width: 100%;
      margin-bottom: ${toVwMobile(32)};

      &:last-child {
        margin-bottom: 0;
      }
    }
  `)};
`;

const ColInfo = styled.div`
  margin-bottom: ${toVw(28)};
`;

const ColInfoText = styled.p`
  margin-bottom: 0;
`;

const ContactsOffices = ({ className, items }) => (
  <Styled className={className}>
    {items.map((item, index) => (
      <Col key={index} data-test="office-info">
        <ColInfo>
          <ColInfoText dangerouslySetInnerHTML={{ __html: item.address }}  />
          <ColInfoText>{item.phone}</ColInfoText>
          <ColInfoText>{item.email}</ColInfoText>
        </ColInfo>
        <ContactsRotator items={item.data} delay={index * 3000} />
      </Col>
    ))}
  </Styled>
);

ContactsOffices.propTypes = {
  className: PropTypes.string,
  items: PropTypes.array.isRequired,
};

export default ContactsOffices;



// WEBPACK FOOTER //
// ./src/scenes/Contacts/components/ContactsOffices.js